export const range = (start:number, end:number) => Array.from(Array(end - start + 1).keys()).map(x => x + start);
export const randomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
